import { createContext } from "react";
import type { ForecastDataPoint, ForecastMetrics } from "../types";

export interface BaseForecastContextType {
  /** The base forecast data points (demo or live depending on mode) */
  baseForecast: ForecastDataPoint[];
  /** Whether the live forecast is currently loading */
  isLoading: boolean;
  /** Error message if live forecast fetch failed */
  error: string | null;
  /** True when no forecast has been run yet (API returned 404) */
  forecastNotReady: boolean;
  /** Forecast metrics from the backend engine (live mode only) */
  metrics: ForecastMetrics | null;
  /** Which CFF layers contributed data (live mode only) */
  availableLayers: string[];
  /** Which CFF layers had no data (live mode only) */
  missingLayers: string[];
  /** Resolution of the forecast data (daily/weekly/monthly/quarterly) */
  resolution: string | null;
  /** The forecast run ID that produced the current data (live mode only) */
  forecastRunId?: number;
  /** Refresh the forecast data (e.g. after recurring transaction changes) */
  refetch: () => void;
}

export const BaseForecastContext = createContext<
  BaseForecastContextType | undefined
>(undefined);
